module.exports = __webpack_public_path__ + "media/images/pic/anime/box-blog-type1-283f47b634d00b983fc05cf9f1176a62.svg";